import React, { PureComponent } from 'react';
import { func, number, oneOfType, string } from 'prop-types';
import styled from 'styled-components';
import { Marker } from 'react-map-gl';
import DefaultPin from '../SolvPatternLibrary/InteractiveMap/DefaultPin';
import { isEmptyObject } from '../../core/util/object';

const CenteredMarker = styled(Marker)`
  transform: translate(-50%, -50%);
  z-index: ${({ highlight }) => (highlight ? Number.MAX_SAFE_INTEGER : 0)};
`;

class MarkerContainer extends PureComponent {
  render() {
    const { latitude, longitude, pin } = this.props;
    const PinClass = !isEmptyObject(pin) ? pin : DefaultPin;
    return (
      <CenteredMarker latitude={parseFloat(latitude)} longitude={parseFloat(longitude)}>
        <PinClass />
      </CenteredMarker>
    );
  }
}

MarkerContainer.propTypes = {
  latitude: oneOfType([number, string]).isRequired,
  longitude: oneOfType([number, string]).isRequired,
  pin: func,
};

export default MarkerContainer;
